import React from "react";
import FeedList from '../components/FeedList';
import EventList from '../components/EventList';
import { Box, Stack, Typography, Button } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import { op } from 'theme';

const Home = () => {
  const {
    loggedIn,
    openPublish,
    errorToShow,
    setShowLogin,
  } = useOutletContext() || {};

  const scrollToEvents = () => {
    document.getElementById('proximos-eventos')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      {/* HERO v2 — un solo glow en reposo por página (IDENTIDAD_VISUAL.md §8.3) */}
      <Box
        sx={{
          borderRadius: '10px',
          overflow: 'hidden',
          // La imagen va encima; si no existe, el gradiente replica el mismo horizonte violeta
          backgroundImage: `url('/images/hero-default.webp'), radial-gradient(120% 70% at 50% 115%, rgba(157,0,255,.55) 0%, rgba(106,0,204,.25) 40%, transparent 72%)`,
          backgroundColor: op.bg.base,
          backgroundSize: 'cover, cover',
          backgroundPosition: 'center bottom, center bottom',
          px: { xs: 3, md: 8 },
          py: { xs: 8, md: 16 },
          textAlign: 'center',
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2rem', sm: '2.75rem', md: '4rem' },
              maxWidth: '18ch',
              color: 'text.primary',
            }}
          >
            Donde el{' '}
            <Box component="span" sx={{ color: op.violet.text }}>
              poder
            </Box>{' '}
            de los geeks se une.
          </Typography>

          <Typography
            variant="body1"
            sx={{ color: 'text.secondary', maxWidth: '52ch', fontSize: { xs: '1rem', md: '1.125rem' } }}
          >
            Convenciones, torneos, ferias y creadores de contenido — todo el mundo geek
            de Costa Rica en un solo lugar.
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={scrollToEvents}
            sx={{
              px: 4,
              py: 1.5,
              boxShadow: op.glow.hero,
              '&:hover': { boxShadow: op.glow.interactive },
            }}
          >
            Ver próximos eventos
          </Button>
        </Stack>
      </Box>

      {/* PRÓXIMOS EVENTOS */}
      <Box id="proximos-eventos" sx={{ px: { xs: 1, md: 2 }, pt: { xs: 6, md: 10 }, textAlign: 'left' }}>
        <Typography variant="h2" component="h2" sx={{ mb: 3 }}>
          Próximos eventos
        </Typography>
        <EventList />
      </Box>

      {/* COMUNIDAD / FEED DE CREADORES */}
      <Box sx={{ px: { xs: 1, md: 2 }, pt: { xs: 6, md: 10 }, textAlign: 'left' }}>
        <Typography variant="h2" component="h2" sx={{ mb: 3 }}>
          Comunidad
        </Typography>
        <FeedList loggedIn={loggedIn} isDirty={openPublish} setErrorToShow={errorToShow} setShowLogin={setShowLogin} />
      </Box>

      {/* BANNER ONBOARDING DE CREADORES — cierre de la Home */}
      <Box
        sx={{
          mt: { xs: 6, md: 10 },
          mb: 4,
          mx: { xs: 1, md: 2 },
          borderRadius: '10px',
          overflow: 'hidden',
          border: `1px solid ${op.border}`,
          backgroundImage: `linear-gradient(90deg, rgba(10,10,18,0) 40%, rgba(10,10,18,.75) 100%), url('/images/banner-creadores.webp')`,
          backgroundColor: op.bg.surface,
          backgroundSize: 'cover, cover',
          backgroundPosition: 'left center, left center',
          px: { xs: 3, md: 8 },
          py: { xs: 6, md: 8 },
          display: 'flex',
          justifyContent: { xs: 'center', md: 'flex-end' },
          textAlign: { xs: 'center', md: 'right' },
        }}
      >
        <Stack spacing={1.5} alignItems={{ xs: 'center', md: 'flex-end' }} sx={{ maxWidth: 520 }}>
          <Typography variant="h2" component="h2">
            ¿Organizás eventos?
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Muy pronto vas a poder publicar tus eventos y actividades en OverPower.TV
            y llegar a toda la comunidad geek de Costa Rica.
          </Typography>
        </Stack>
      </Box>
    </div>
  );
};

export default Home;
